import { useRouteMatch } from 'react-router-dom';

export default (): string | undefined => {
  const routeMatch = useRouteMatch<{ [householdId: string]: string }>('/:householdId');
  return routeMatch?.params.householdId;
};
